import { render, staticRenderFns } from "./MenuColor.vue?vue&type=template&id=03acd14c&scoped=true&lang=html"
import script from "./MenuColor.vue?vue&type=script&lang=js"
export * from "./MenuColor.vue?vue&type=script&lang=js"
import style0 from "./MenuColor.vue?vue&type=style&index=0&id=03acd14c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03acd14c",
  null
  
)

export default component.exports